import { apiRequest } from "../api";

export const getProfile = () => apiRequest("/profile", "GET");
export const updateProfile = (payload: unknown) =>
  apiRequest("/profile/update", "PUT", payload);
export const updatePassword = (payload: unknown) =>
  apiRequest("/password/update", "PUT", payload);
